import type { TourDefinition } from "@/types/tour";

export const marketInsightsListTour: TourDefinition = {
  id: "market-insights-list",
  context: "terminus-admin",
  version: 1,
  path: "/market-insights",
  steps: [
    {
      element: '[data-tour-id="mi-stats-row"]',
      popover: {
        title: "Overview at a glance",
        description:
          "These cards summarize your market insights pipeline. Click any card to filter the list below by that status.",
      },
    },
    {
      element: '[data-tour-id="mi-create-button"]',
      popover: {
        title: "Create new insight",
        description:
          "Start a new market research by uploading documents. The AI will extract opportunities and generate theses automatically.",
      },
    },
    {
      element: '[data-tour-id="mi-filters"]',
      popover: {
        title: "Search & filter",
        description:
          "Filter by industry category, search by name, and paginate through your insights.",
      },
    },
    {
      element: '[data-tour-id="mi-list"]',
      popover: {
        title: "Your market insights",
        description:
          "Each row shows a market insight with its status, sector, and data completeness. The colored bar on the left indicates processing progress.",
      },
    },
    {
      element: '[data-tour-id="mi-list-item"]',
      popover: {
        title: "Click & right-click",
        description:
          "Click any item to view its details. Right-click for extra actions like edit, retry processing, or delete.",
      },
    },
  ],
};
